import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../redux/store/store";
import { logout as clearAuthSession } from "../redux/slice/authSlice";
import { logout } from "../redux/slice/layoutSlice";
import { useLogoutMutation } from "../redux/api/platform/tokenApi";
import { OrganizationGrid } from "../components/OrganizationGrid";
import { Logo } from "../layout/Logo";

// Full-screen organization picker shown after login (org users only). Picking a
// card enters that organization; see OrganizationGrid.
const OrganizationLobby = () => {
  const dispatch = useDispatch<AppDispatch>();
  const name = useSelector((s: RootState) => s.layout.user.name);
  const [logoutMutation] = useLogoutMutation();

  const handleLogout = () => {
    const sessionToken = localStorage.getItem("sessionToken");
    if (sessionToken) {
      logoutMutation(sessionToken)
        .unwrap()
        .catch(() => undefined);
    }
    dispatch(clearAuthSession());
    dispatch(logout());
  };

  return (
    <div className="lobby">
      <div className="lobby__card">
        <div className="lobby__head">
          <Logo />
          <h1>Select an organization</h1>
          <p>
            Hi {name?.split(" ")[0] || "there"} — choose which organization you
            want to work in.
          </p>
        </div>

        <OrganizationGrid />

        <button
          type="button"
          className="btn btn--ghost lobby__logout"
          onClick={handleLogout}
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default OrganizationLobby;
